export default __webpack_public_path__ + "static/media/fog.87538f81.jpg";